<template>
  <div class="announce">
    <div class="container">
      <div class="rowView pageFirstView">
        <div class="areaPageTitle">
          <h1>News</h1>
        </div>
      </div>
    </div>

		<div v-show="checkHideContents(SecondLayer)">
			<div class="container">
				<div class="rowView">
					<sort-panel @parentMethod="updateList" :origin=originList :page-range="10" :page-num=currentPage v-if="setListPanel"></sort-panel>
					<any-list @createDetail="createDetail" :display-list="displayList" :any-list="3"></any-list>
				</div>
			</div>
		</div>

		<router-view v-on:changeDetail="setDetail"></router-view>
  </div>
</template>

<script>
import sortPanel from '@/components/SortPanel.vue'
import anyList from '@/components/AnyList.vue'

export default {
  name: 'announcement',
  components:{
    sortPanel, 
		anyList,
  },
  data: function () {
    return {
      originList:[],
      displayList:[],
			orderList:[],
			currentPage:1,
      detailIndex:0,
			detailName:'',
			pageTitle:"お知らせ",
			description:"豊嶋精密工業株式会社からのお知らせ一覧です",
			keywords:"お知らせ",
			ogType:"article",
    }
  },
  computed: {
		setListPanel:function() {
/*直呼び出しの場合、jsonが揃ってから構築しないと、再構築してくれない。*/
			return this.originList.length > 0
		}
	},
  beforeCreate: function() {console.log("beforeCreate "+this.$options.name)
//console.dir(this.displayList) //< displayListが存在しない
	},
	created:function() {console.log("created "+this.$options.name)
//console.dir(this.displayList)  //< displayListは定義済みだが、中身はない
	},
  beforeMount:function() {console.log("beforeMount "+this.$options.name)
//ページ初期構築時の情報をセットする
		this.setList()
/*パラメータに?list=2の表記があった場合はその対象リストを表示するようにする*/
		if(this.$route.query.list) {
			this.currentPage = Number(this.$route.query.list)
		}
//console.dir(this.displayList)  //初期化済みで中身あり。 +sortPanel beforeMount
  },
  mounted: function() {console.log("mounted "+this.$options.name)

/*子が呼び出されているときは、以下をセットしないようにしないといけない*/
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', 'appBackgroundBase')
	
/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)

			if(this.currentPage == 1) {
				this.$store.commit('updateLinkCanonical', 'https://toyoshimaseimitsu.co.jp/about/announcement?list=1')
			} else {
				this.$store.commit('updateLinkCanonical', '')
			}
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
	
			this.changePageScrollAnchor()
		}
  },
  beforeUpdate:function() {console.log("beforeUpdate "+this.$options.name)

/*ブラウザー戻る進む処理変化の場合は、欠損するデータを補う*/
/*vue-routerで指定するやり方では動かず*/
		if(this.$route.params.anyList == undefined) {
			this.$route.params.anyList = 3 //セットできる プロパティもある状態でセット可能
		}
		if(this.$route.params.detail == undefined) {
			this.detailName = this.$route.params.pageId
			let aIndex =  this.displayList.findIndex(({title}) => title === this.detailName)
			this.detailIndex = aIndex
      let aImg = this.displayList[aIndex]
			this.$route.params.detail  = aImg
		}

		if(this.$route.query.list) {
/*ブラウザーリロード処理変化の場合は、urlに合わせたリスト表示を更新する必要がある*/
			let aPageNumber = Number(this.$route.query.list)
			if(aPageNumber != this.currentPage) {
				this.currentPage = aPageNumber
			}
		} else {
				this.currentPage = 1
		}
	},
  updated:function() {console.log("updated "+this.$options.name)

/*子が呼び出されているときは、以下をセットしないようにしないといけない*/
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', 'appBackgroundBase')

/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)

			if(this.currentPage == 1) {
				this.$store.commit('updateLinkCanonical', 'https://toyoshimaseimitsu.co.jp/about/announcement?list=1')
			} else {
				this.$store.commit('updateLinkCanonical', '')
			}
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())

			this.changePageScrollAnchor()
		}
  },
  methods:{
    createDetail(aImg, index){
      this.detailIndex = index
      this.$router.push({
          name: 'お知らせ詳細',
          params: {
							pageId:aImg.title,
              anyList:3,
              detail:aImg
          }
      })
    },
    setDetail:function(aFor) {
      this.detailIndex += aFor
      if(this.orderList.length <= this.detailIndex) {
        this.detailIndex = 0
      } else if(this.detailIndex < 0 ) {
        this.detailIndex = this.orderList.length-1
      }
      let aImg = this.orderList[this.detailIndex]
      this.$router.push({
          name: 'お知らせ詳細',
          params: { 
							pageId:aImg.title,
              anyList:3,
              detail:aImg
          }
      }).catch(()=>{})
    },
    setList() {
			if(this.$store.getters.originListInformation .length == 0 ) {
				/*データがない場合は、storeの状態を監視して、読み込み終了とともにセットする*/
				this.detailName = decodeURI(this.$route.path.match(/([^\/.]+)/g).pop())
				if(this.detailName != 'announcement') {
/*詳細ページの場合は一度、リストページに戻す*/
					this.$router.push({path:"/about/announcement?list=1"})
				}else{
/*リストページの場合*/
					this.detailName = ''
				}
				this.$store.watch(
					(state, getters) => getters.originListInformation,
					(newValue, oldValue) => {
console.log("LOADED")
						this.originList = this.$store.getters.originListInformation
						this.resetList()
/*詳細ページの場合は以下が必要*/
						if(this.detailName != '') {
							this.rePushDetail()
						}
					}
				)
			} else {
				this.originList = this.$store.getters.originListInformation
				this.resetList()
			}
    },
    resetList() {
			this.displayList = Object.assign([], this.originList)
			this.orderList = Object.assign([], this.originList)
    },
    updateList(aDisplayList, aDisplayListAll, aPageNumber) {
/*子から呼び出す表示更新メソッド*/
      this.displayList = aDisplayList
			this.orderList = aDisplayListAll
			if(aPageNumber != this.currentPage) {
				this.currentPage = aPageNumber
				this.$router.push({
					name: 'お知らせ',
					query: { 
							list:this.currentPage,
					}
				})
			}
    },
		rePushDetail() {
			let aIndex =  this.displayList.findIndex(({title}) => title === this.detailName)
			this.detailIndex = aIndex
      let aImg = this.displayList[aIndex]
      this.$router.push({
          name: 'お知らせ詳細',
          params: { 
              pageId:aImg.title,
              anyList:3,
              detail:aImg
          }
      })
		},
  },
}
</script>


<style>
</style>
